import type { BaseError as ViemBaseError } from "viem"
import { UnknownRpcError } from "viem"
import type { BaseError as WagmiBaseError } from "wagmi"
import { walk } from "./walk"

export function isUnknownRpcError(
  error: WagmiBaseError | ViemBaseError,
): boolean {
  return !!walk(error, e => e instanceof UnknownRpcError)
}
